module.exports = __webpack_public_path__ + "static/media/page not found.a4a19e60.png";